export const lamp = {
	/**
	* Gets the programmatic name of the entire locale, with the language,
	*	country and variant separated by underbars. The Language is always lower case,
	*	and country is always upper case. If the language is missing,
	*	the string will begin with an underscore character.
	*	If both the language and country fields are missing,
	*	this function will return the empty string,
	*	even if the variant field is filled in (you cannot have a locale with just a variant--
	*	the variant must accompany a valid language or country code). Examples: "en"
	*
	*/
    en: {
        lamp:'Lamp',
        lamp_no:'Lamp No',
        lamp_information:'Lamp Information',
        lamp_id:'Lamp Id',
        lamp_management:'Lamp Management',
        add_lamp:'Add Lamp',
        edit_lamp:'Edit Lamp',
        lamp_name:'Lamp Name',
        status:'Status',
        delete_confrim_msg:"Are you sure you want to delete this lamp?",
        lamps:"lamps"
    },
    ar: {
        lamp:'المصباح',
        lamp_no:'رقم المصباح',
        lamp_information:'معلومات المصباح',
        lamp_id:'معرف المصباح',
        lamp_management:'إدارة المصباح',
        add_lamp:'أضف المصباح',
        edit_lamp:'تحرير المصباح',
        lamp_name:'اسم المصباح',
        status:'الحالة',
        delete_confrim_msg:"هل أنت متأكد أنك تريد حذف هذا المصباح؟",
        lamps:"مصابيح"
    }
}
